module.exports = __webpack_public_path__ + "img/calendar3-range.adac3a40.svg";